import React from "react";
import { Trans } from "react-i18next";

export default class LoginBanner extends React.Component {
  render() {
    return (
      <div className="login-holder-2">
        <img
          src={require("WebsiteApp/assets/img/card_example_updated3.png")}
          className=""
          alt=""
          style={{ maxWidth: 350 }}
        />
        <Trans>
          <p>
            Stay in control of your money 24/7.
            <br />
            Log in to activate your card, check your balance,
            <br />
            view and download statements, lock your card and more.
          </p>
        </Trans>
        <a
          href="https://www.onepay.co.uk/help-centre?hsCtaTracking=ba5837cb-806a-4960-9094-3086547a43fe%7C011b638c-7cdb-41ec-b3e6-b7d6b81e2142"
          target="_blank"
          rel="noopener noreferrer"
          className="orange-button"
        >
          <Trans>Contact OnePay</Trans>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/components/LoginBanner.js